/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { Dropdown, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as Constants from '../../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import * as actiontype from './store/actiontypes';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
  autoFormateDate,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  compareQtrs,
  closeTab,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  API_TIMEOUT_ERROR,
  FAIL_PROCESSING_REQUEST,
  SUCCESSMESSAGE_PRICE,
  VALIDATE_QUARTER_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  allManufacturer,
  errorMsg,
  setFieldErr,
  getArSummaryAllRpc,
  getArSummaryByQtr,
  getDramsStartQtr,
  getManuARForAllRpc,
  getManuARForSglRpc,
  getMaxQtrFreezeDt,
  getPlanTypes,
  getRebateProgram,
  getSummaryStartQtr,
  selectedDisplayBy,
  selectedPlan,
  selectedQtrOpt,
  selectedFromQtr,
  selectedToQtr,
  selectedRebatePgm,
  selectedURAToUse,
  selectRebateList,
  storeManufacturesList,
  updateAllRebate,
  updateFirstLoad,
} from './store/actions';
import { columnDefs } from '../tablehead';
import {
  REQ_ACC_REC_ROUTE,
  AR_SUMRY_MFG_ALL,
  FROM_QTR_ERR,
  TO_QTR_ERR,
  DRAMS_QTR_ERR,
  FIRST_SMRY_QTR_ERR,
  REBATE_PGM_REQ,
  MFG_REQ_ERR,
} from '../AccountsRevConstants';
import {
  goToArSummaryMfg,
  gotoArSummaryMfgAll,
  goToArSummaryQtr,
  goToMfgAccRec,
  gotoArSummaryQtrAll,
} from '../ARCommonFunctions';
import { mfgARFirstLoad } from '../MfgAccountsRec/store/actions';

const ReqAccReceivable = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [saveMsg, setSaveMsg] = React.useState([]);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [singleManu, setSingleManu] = React.useState(null);
  const [load, setLoad] = React.useState(false);
  const [radioList, setRadioList] = React.useState([]);

  const {
    all_rebate,
    err_list,
    flderror,
    plan_list,
    rebate_list,
    plan_type,
    rebate_pgm,
    ura_to_use,
    display_by,
    qtr_opt,
    acc_qtr_from,
    acc_qtr_to,
    all_manu,
    manu_list,
    end_qtr,
    start_qtr,
    ar_smry_mfg,
    ar_smry_qtr,
    rbt_list,
    firstload,
    mfg_all_rpc,
  } = useSelector((state) => state?.sharedState?.AccountRecReducer);
  const planTypeCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const rebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const defRptQtrSelectCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.defRptQtrSelectCd
  );
  const blurHandler = (val, fld) => {
    let err = [...err_list];
    let fldErr = { ...flderror };
    let remErrArr = [];
    switch (fld) {
      case 'fromQtr':
        if (qtr_opt === 'Quarter') {
          remErrArr = flderror?.qtrToValidErr
            ? [FROM_QTR_ERR]
            : [FROM_QTR_ERR, VALIDATE_QUARTER_VALUE];
          err = removeErr(err, remErrArr);
          fldErr = { ...fldErr, qtrFromReqErr: false, qtrFromValidErr: false };

          if (!val) {
            err = [...new Set([...err, FROM_QTR_ERR])];
            fldErr = { ...fldErr, qtrFromReqErr: true };
          } else if (val && !checkQuarterValidation(val)) {
            err = [...new Set([...err, VALIDATE_QUARTER_VALUE])];
            fldErr = { ...fldErr, qtrFromValidErr: true };
          } else if (val && checkQuarterValidation(val)) {
            const value = autoFormateDate(val.toUpperCase());
            dispatch(selectedFromQtr(value));
            if (!acc_qtr_to) dispatch(selectedToQtr(value));
          }
        }
        break;
      case 'toQtr':
        if (qtr_opt === 'Quarter') {
          if (!flderror?.qtrFromValidErr)
            err = removeErr(err, [VALIDATE_QUARTER_VALUE]);

          fldErr = { ...fldErr, qtrToValidErr: false };
          err = removeErr(err, [TO_QTR_ERR]);

          if (val && !checkQuarterValidation(val)) {
            err = [...new Set([...err, VALIDATE_QUARTER_VALUE])];
            fldErr = { ...fldErr, qtrToValidErr: true };
          } else if (
            val &&
            !compareQtrs(val, acc_qtr_from) &&
            val !== acc_qtr_from
          ) {
            err = [...new Set([...err, TO_QTR_ERR])];
            fldErr = { ...fldErr, qtrToValidErr: true };
          } else if (
            !val &&
            acc_qtr_from &&
            checkQuarterValidation(acc_qtr_from)
          ) {
            dispatch(selectedToQtr(acc_qtr_from));
          } else if (val && checkQuarterValidation(val)) {
            dispatch(selectedToQtr(autoFormateDate(val.toUpperCase())));
          }
        }
        break;
      default:
      // Default case
    }

    dispatch(errorMsg(err));
    dispatch(setFieldErr(fldErr));
  };

  const cellClickedListener = (params) => {
    const [selectedRow] = params.api.getSelectedRows();
    setSingleManu(selectedRow);
    const err = removeErr(err_list, [MFG_REQ_ERR]);
    dispatch(errorMsg(err));
    onSearch(selectedRow);
  };

  const onSearch = async (sglManu) => {
    let err = [];
    let fldErr = {};

    if (!all_manu && !singleManu && display_by === 'Manufacturer')
      err.push(MFG_REQ_ERR);
    if (!all_rebate && (!rebate_pgm || rebate_pgm === '-1'))
      err.push(REBATE_PGM_REQ);
    if (qtr_opt === 'drams' && !start_qtr) err.push(DRAMS_QTR_ERR);
    if (qtr_opt === 'summary' && !start_qtr) err.push(FIRST_SMRY_QTR_ERR);
    if (qtr_opt === 'Quarter') {
      if (!acc_qtr_from) {
        err.push(FROM_QTR_ERR);
        fldErr = { ...fldErr, qtrFromReqErr: true };
      } else if (acc_qtr_from && !checkQuarterValidation(acc_qtr_from)) {
        err.push(VALIDATE_QUARTER_VALUE);
        fldErr = { ...fldErr, qtrFromValidErr: true };
      }

      if (acc_qtr_to && !checkQuarterValidation(acc_qtr_to)) {
        err.push(VALIDATE_QUARTER_VALUE);
        fldErr = { ...fldErr, qtrToValidErr: true };
      } else if (
        acc_qtr_to &&
        !compareQtrs(acc_qtr_to, acc_qtr_from) &&
        acc_qtr_to !== acc_qtr_from
      ) {
        err = [...new Set([...err, TO_QTR_ERR])];
        fldErr = { ...fldErr, qtrToValidErr: true };
      }
    }

    if (err.length > 0) {
      err = [...new Set(err)];
      dispatch(errorMsg(err));
      dispatch(setFieldErr(fldErr));
      return;
    }

    setLoad(true);
    const enddt = qtr_opt !== 'Quarter' ? end_qtr : acc_qtr_to;
    const startdt =
      qtr_opt === 'All'
        ? '1Q1991'
        : qtr_opt === 'Quarter'
        ? acc_qtr_from
        : start_qtr;
    const rbtVal = rebate_list.filter(
      (o) => o.rebateProgramCd === rebate_pgm
    )[0];
    let obj = {
      pgmInfo: all_rebate
        ? 'All | All Rebate Programs'
        : `${rbtVal.rebateProgramCd} | ${rbtVal.shortDescr}`,
      pgmCd: rebate_pgm,
      qtrInfo:
        qtr_opt === 'All'
          ? 'All Quarters'
          : qtr_opt === 'drams'
          ? `DRAMS Invoice Start QTR ${start_qtr} - ${end_qtr}`
          : qtr_opt === 'summary'
          ? `First Summary Report Qtr ${start_qtr} - ${end_qtr}`
          : qtr_opt === 'Quarter'
          ? `${acc_qtr_from} - ${acc_qtr_to}`
          : '',
      uraInfo: ura_to_use,
    };
    if (display_by === 'Manufacturer') {
      if (all_manu) {
        // const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
        // if (
        //   all_rebate &&
        //   updateTabs.some((ob) => ob.navTo === AR_SUMRY_MFG_ALL)
        // ) {
        //   props.history.push({ pathname: AR_SUMRY_MFG_ALL });
        //   return;
        // }
        const payload = {
          planType: plan_type,
          startQtr: startdt,
          endQtr: enddt,
          useOfficialURA: ura_to_use === 'Official' ? 1 : 0,
          allRebateProgramIndicator: all_rebate ? 1 : 0,
          allMfgIndicator: all_manu ? 1 : 0,
          rebateProgramCode: rebate_pgm,
          mfgId: !all_manu ? singleManu.mfgId : '',
        };
        dispatch(getArSummaryAllRpc(payload, { ...payload, ...obj }));
      } else if (!all_manu) {
        let payload = {
          planType: plan_type,
          mfgId: sglManu.mfgId ? sglManu.mfgId : singleManu.mfgId,
          startQtr: startdt,
          endQtr: enddt,
          useOfficialURA: ura_to_use === 'Official' ? 1 : 0,
        };
        obj = {
          ...obj,
          mfgName: sglManu.mfgName ? sglManu.mfgName : singleManu.mfgName,
        };
        if (all_rebate)
          dispatch(getManuARForAllRpc(payload, { ...payload, ...obj }));
        else {
          payload = { ...payload, rebateProgram: rebate_pgm };
          dispatch(getManuARForSglRpc(payload, { ...payload, ...obj }));
        }
      }
    } else if (display_by === 'Quarter') {
      const payload = {
        rebateProgram: all_rebate ? 'All' : rebate_pgm,
        startQuarter: startdt,
        endQuarter: enddt,
        useOfficialUra: ura_to_use === 'Official' ? 1 : 0,
      };
      //dispatch(getArSummaryByQtr(payload, { ...obj, ...payload }));

      try {
        await dispatch(getArSummaryByQtr(payload, { ...obj, ...payload }));
      } catch (error) {
      } finally {
        setLoad(false);
      }
    }
  };

  // const resetData = () => {
  //   dispatch({ type: actiontype.ACC_RESET_STORE });
  // };

  const onSelectionChanged = (params) => {
    const [selectedRow] = params.api.getSelectedRows();
    setSingleManu(selectedRow);
    const err = removeErr(err_list, [MFG_REQ_ERR]);
    dispatch(errorMsg(err));
  };

  React.useEffect(() => {
    if (!plan_list) dispatch(getPlanTypes());
    if (!end_qtr) dispatch(getMaxQtrFreezeDt());
    if (!rbt_list) dispatch(selectRebateList());
  }, []);

  React.useEffect(() => {
    if (plan_list) {
      const planList = plan_list?.PLAN_TYPE_CD?.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList?.filter((obj) => obj?.name == 'Medicaid'),
        ...planList?.filter((obj) => obj?.name !== 'Medicaid'),
      ]);
      if (firstload) {
        dispatch(updateFirstLoad());
        if (rebateProgramCd) dispatch(selectedRebatePgm(rebateProgramCd));
        if (planTypeCd) dispatch(selectedPlan(planTypeCd));
        else if (!plan_type) dispatch(selectedPlan('FD'));
        if (defRptQtrSelectCd) {
          if (defRptQtrSelectCd === 'A') dispatch(selectedQtrOpt('All'));
          if (defRptQtrSelectCd === 'D') dispatch(selectedQtrOpt('drams'));
        }
      }
    }
  }, [plan_list]);

  React.useEffect(() => {
    if (plan_type) dispatch(getRebateProgram(plan_type));
  }, [plan_type]);

  React.useEffect(() => {
    setLoad(false);
  }, [manu_list]);
  
React.useEffect(() => {
    if (rebate_pgm && rebate_pgm != '-1') {
      dispatch(
        getDramsStartQtr(
          { rebateProgCode: rebate_pgm, allRpc: all_rebate ? 1 : 0 },
          err_list
        )
      );
    }
  }, [rebate_pgm, all_rebate]);

  React.useEffect(() => {
    if (err_list.length > 0) {
      if (
        err_list?.[0] === API_TIMEOUT_ERROR ||
        err_list?.[0] === FAIL_PROCESSING_REQUEST
      ) {
        setLoad(false);
      }
      tabHighLigther(REQ_ACC_REC_ROUTE, true);
    } else {
      tabHighLigther(REQ_ACC_REC_ROUTE, false);
    }
  }, [err_list]);

  React.useEffect(() => {
    if (ar_smry_mfg) {
      if (ar_smry_mfg.message === 'Success' && ar_smry_mfg.status === '001') {
        if (all_rebate) gotoArSummaryMfgAll(props.history, dispatch);
        else goToArSummaryMfg(props.history, rebate_pgm, dispatch);
        dispatch({ type: actiontype.AR_SMRY_FOR_MFG, payload: null });
      }
    }
  }, [ar_smry_mfg]);

  // get ar summary manufacturer data from redux
  React.useEffect(() => {
    if (mfg_all_rpc) {
      if (mfg_all_rpc.message === 'Success' && mfg_all_rpc.status === '001') {
        goToMfgAccRec(props.history, dispatch, {
          rebateProgram: all_rebate ? 'All' : rebate_pgm,
          mfgId: singleManu.mfgId,
        });
        dispatch(mfgARFirstLoad(false));
        dispatch({ type: actiontype.MFG_AR_ALL_RPC, payload: null });
      }
    }
  }, [mfg_all_rpc]);

  // get ar summary quarter data from redux
  React.useEffect(() => {
    if (ar_smry_qtr) {
      if (all_rebate) gotoArSummaryQtrAll(props.history, dispatch);
      else goToArSummaryQtr(props.history, rebate_pgm, dispatch);
      dispatch({ type: actiontype.AR_SMRY_FOR_QTR, payload: null });
    }
  }, [ar_smry_qtr]);

  // Remove Quarter validation errors if Report Quarter Option is not selected as Quarter
  React.useEffect(() => {
    if (qtr_opt !== 'Quarter') {
      let err = [...err_list];
      let fldErr = { ...flderror };

      err = removeErr(err_list, [FROM_QTR_ERR, VALIDATE_QUARTER_VALUE]);

      fldErr = {
        ...fldErr,
        qtrFromReqErr: false,
        qtrFromValidErr: false,
        qtrToValidErr: false,
      };

      dispatch(errorMsg(err));
      dispatch(setFieldErr(fldErr));

      dispatch(selectedFromQtr(''));
      dispatch(selectedToQtr(''));
    }
  }, [qtr_opt]);

  const removeQtrErr = () => {
    const err = removeErr(err_list, [
      DRAMS_QTR_ERR,
      FIRST_SMRY_QTR_ERR,
      VALIDATE_QUARTER_VALUE,
      FROM_QTR_ERR,
      TO_QTR_ERR,
    ]);
    dispatch(errorMsg(err));
  };
  const [gridApi, setGridApi] = React.useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || manu_list === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows?.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
    }
  }, [gridApi, manu_list]);

  return (
    <div className='tabs-container' data-testid='ReqAccReceivable'>
      <Spinner load={load} />
      <CustomSeparator parent1='Research' parent2='Accounts Receivable' />
      <DisplaySuccessMessages successMessages={saveMsg} />
      <ErrorMessages errorMessages={err_list} />
      {!fullScreen && (
        <>
          <div className='col-12 mb-3'>
            <FormControlLabel
              control={<Checkbox color='primary' />}
              label='All Rebate Programs'
              value={all_rebate}
              onChange={(e, val) => {
                dispatch(updateAllRebate(val));
                if (val) {
                  const err = removeErr(err_list, [REBATE_PGM_REQ]);
                  dispatch(errorMsg(err));
                  // dispatch(selectedRebatePgm('-1'));
                  if (qtr_opt === 'drams') {
                    dispatch(
                      getDramsStartQtr(
                        { rebateProgCode: rebate_pgm, allRpc: 1 },
                        err_list
                      )
                    );
                  } else if (qtr_opt === 'summary') {
                    dispatch(
                      getSummaryStartQtr(
                        { rebateProgCode: rebate_pgm, allRpc: 1 },
                        err_list
                      )
                    );
                  }
                }
                if (!all_manu) {
                  setLoad(true);
                  dispatch(
                    storeManufacturesList({
                      planType: plan_type,
                      isAllRpc: val,
                    })
                  );
                }
              }}
              checked={all_rebate}
              data-testid='check-box-change'
            />
            <div className='float-right '>
              <Button
                className='btn btn-success btn-save frr-ar-custom-margin'
                data-testid='searchBTN'
                onClick={onSearch}
              >
                <SVGComponent iconName='Icon-search' /> Search
              </Button>
              {/* <Button
                className="btn btn-cancel"
                data-testid="resetBTN"
                onClick={resetData}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button> */}
            </div>
            <div className='clearfix' />
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-6 col-xl-8'>
              <fieldset className='custom-fieldset h-100'>
                <legend className='same-font-family'>Plan Type</legend>
                <div className='sub-radio no-margin '>
                  <FormControl>
                    <RadioGroup
                      row
                      name='acc-plan-row-radio-buttons-group'
                      defaultValue={plan_type}
                      value={plan_type}
                    >
                      {plan_list && !_.isEmpty(radioList)
                        ? radioList.map((v, i) => (
                            <FormControlLabel
                              value={v.value}
                              control={
                                <Radio
                                  onChange={(e) => {
                                    removeQtrErr();
                                    dispatch(selectedPlan(v.value));
                                    dispatch(selectedRebatePgm('-1'));
                                    if (!all_manu) {
                                      setLoad(true);
                                      dispatch(
                                        storeManufacturesList({
                                          planType: v.value,
                                          isAllRpc: all_rebate,
                                        })
                                      );
                                    }
                                  }}
                                />
                              }
                              disabled={!!all_rebate}
                              label={v.name}
                              key={v.value && _.kebabCase(v.value)}
                              data-testid='radio-box-change-control'
                            />
                          ))
                        : null}
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className='col-12 col-lg-8 col-md-4 col-xl-4 mui-custom-form no-margin pl-0'>
                  <div className='input-md mandate-fields'>
                    <TextField
                      className='mb-3'
                      id='rebate_pgm'
                      inputProps={{
                        id: 'rebate_pgm',
                      }}
                      label='Rebate Program'
                      required={!all_rebate}
                      select
                      data-testid='rebateProgram'
                      value={rebate_pgm || '-1'}
                      onChange={(e) => {
                        const val = e.target.value;
                        dispatch(selectedRebatePgm(val));
                        if (val === '-1') {
                          const err = [
                            ...new Set([...err_list, REBATE_PGM_REQ]),
                          ];
                          dispatch(errorMsg(err));
                        } else {
                          const err = removeErr(err_list, [REBATE_PGM_REQ]);
                          dispatch(errorMsg(err));
                          if (qtr_opt === 'drams') {
                            dispatch(
                              getDramsStartQtr(
                                { rebateProgCode: val, allRpc: 0 },
                                err_list
                              )
                            );
                          } else if (qtr_opt === 'summary') {
                            dispatch(
                              getSummaryStartQtr(
                                { rebateProgCode: val, allRpc: 0 },
                                err_list
                              )
                            );
                          }
                        }
                      }}
                      disabled={!!all_rebate}
                      error={
                        err_list && err_list.some((o) => o === REBATE_PGM_REQ)
                      }
                    >
                      <MenuItem
                        key=''
                        value='-1'
                        className='frr-dropdown-blank-item'
                      />
                      {rebate_list &&
                        rebate_list.map((item, ind) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className='col-sm-6 mt-sm-3 col-md-6 mt-md-3  mt-lg-0 col-lg-3 col-xl-2'>
              <fieldset
                className='custom-fieldset py-1'
                style={{ height: 'auto' }}
              >
                <legend className='same-font-family'>URA To Use</legend>
                <div className='sub-radio no-margin '>
                  <FormControl>
                    <RadioGroup
                      row
                      className='py-3 frr-no-wrap'
                      name='acc-ura-row-radio-buttons-group'
                      defaultValue={ura_to_use}
                      value={ura_to_use}
                    >
                      <FormControlLabel
                        value='Official'
                        control={
                          <Radio
                            onChange={() =>
                              dispatch(selectedURAToUse('Official'))
                            }
                          />
                        }
                        disabled={false}
                        label='Official'
                        key={_.kebabCase('Official')}
                        data-testid='Official-URA'
                      />
                      <FormControlLabel
                        value='Most Recent'
                        control={
                          <Radio
                            onChange={() =>
                              dispatch(selectedURAToUse('Most Recent'))
                            }
                          />
                        }
                        disabled={false}
                        label='Most Recent'
                        key={_.kebabCase('Most Recent')}
                        data-testid='Most-Recent-URA'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </fieldset>
            </div>
            <div className='col-sm-6 mt-sm-3 col-md-6 mt-md-3  mt-lg-0 col-lg-3 col-xl-2'>
              <fieldset
                className='custom-fieldset py-1 px-1'
                style={{ height: 'auto' }}
              >
                <legend className='same-font-family'>Display By</legend>
                <div className='sub-radio no-margin '>
                  <FormControl>
                    <RadioGroup
                      row
                      className='py-3'
                      name='acc-dsp-row-radio-buttons-group'
                      defaultValue={display_by}
                      value={display_by}
                    >
                      <FormControlLabel
                        value='Manufacturer'
                        control={
                          <Radio
                            onChange={() =>
                              dispatch(selectedDisplayBy('Manufacturer'))
                            }
                          />
                        }
                        disabled={false}
                        label='Manufacturer'
                        key={_.kebabCase('Manufacturer')}
                        data-testid='Manufacturer-Display-By'
                      />
                      <FormControlLabel
                        value='Quarter'
                        control={
                          <Radio
                            onChange={() =>
                              dispatch(selectedDisplayBy('Quarter'))
                            }
                          />
                        }
                        disabled={false}
                        label='Quarter'
                        key={_.kebabCase('Quarter')}
                        data-testid='Quarter-Display-By'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </fieldset>
            </div>
          </div>
          <div className='col-sm-12 px-0 mt-3'>
            <fieldset className='custom-fieldset' style={{ height: 'auto' }}>
              <legend className='same-font-family'>
                Report Quarter Option
              </legend>
              <div className='sub-radio no-margin'>
                <FormControl>
                  <RadioGroup
                    row
                    name='acc-qtr-row-radio-buttons-group'
                    defaultValue={qtr_opt}
                    value={qtr_opt}
                  >
                    <div
                      className='row align-items-center'
                      style={{ width: '68%' }}
                    >
                      <div className='col-12 col-md-12 col-lg-12 col-xl-6 frr-report-quarter'>
                        <FormControlLabel
                          value='All'
                          control={
                            <Radio
                              onChange={() => {
                                dispatch(selectedQtrOpt('All'));
                                removeQtrErr();
                              }}
                            />
                          }
                          disabled={false}
                          label='All'
                          key={_.kebabCase('All')}
                          data-testid='All-Rpt-Qtr-Opt'
                        />
                      </div>
                      <div className='col-12 col-md-12 col-lg-12 col-xl-6 frr-no-wrap frr-report-quarter'>
                        <FormControlLabel
                          value='summary'
                          control={
                            <Radio
                              onChange={() => {
                                if (all_rebate || rebate_pgm !== '-1') {
                                  dispatch(
                                    getSummaryStartQtr(
                                      {
                                        rebateProgCode: rebate_pgm,
                                        allRpc: all_rebate ? 1 : 0,
                                      },
                                      err_list
                                    )
                                  );
                                  removeQtrErr();
                                }
                                dispatch(selectedQtrOpt('summary'));
                              }}
                            />
                          }
                          disabled={false}
                          label='First Summary Report Quarter'
                          key={_.kebabCase('First Summary Report Quarter')}
                          data-testid='Summary-Rpt-Qtr-Opt'
                        />
                      </div>
                    </div>
                    <div
                      className='row align-items-center '
                      style={{ width: '100%' }}
                    >
                      <div className='col-12 col-md-12 col-lg-12 col-xl-4 frr-report-quarter'>
                        <FormControlLabel
                          value='drams'
                          className='frr-no-wrap'
                          control={
                            <Radio
                              onChange={() => {
                                if (all_rebate || rebate_pgm !== '-1') {
                                  dispatch(
                                    getDramsStartQtr(
                                      {
                                        rebateProgCode: rebate_pgm,
                                        allRpc: all_rebate ? 1 : 0,
                                      },
                                      err_list
                                    )
                                  );
                                  removeQtrErr();
                                }
                                dispatch(selectedQtrOpt('drams'));
                              }}
                            />
                          }
                          disabled={false}
                          label='DRAMS Invoice Start Quarter'
                          key={_.kebabCase('DRAMS Invoice Start Quarter')}
                          data-testid='Drams-Display-By'
                        />
                      </div>
                      <div className='align-items-center col-8 col-sm-12 col-md-8 col-lg-12 col-md-12 col-xl-8 dif frr-report-quarter1 px-0'>
                        <div className='col-6 col-lg-4 col-xl-6 pr-0  pl-lg-2 pl-xl-3'>
                          <FormControlLabel
                            className='frr-no-wrap'
                            value='Quarter'
                            control={
                              <Radio
                                onChange={() => {
                                  dispatch(selectedQtrOpt('Quarter'));
                                  removeQtrErr();
                                }}
                              />
                            }
                            disabled={false}
                            label='Selected Quarter Range'
                            key={_.kebabCase('Selected Quarter Range')}
                            data-testid='Selected-Qtr'
                          />
                        </div>
                        {/* <div className=""> */}
                        <div className='mui-custom-form no-margin  col-3 no-lbl pl-0 pr-2 mandate-fields'>
                          <TextField
                            value={acc_qtr_from}
                            id='qtr_from'
                            className='frr-display-hidden-label'
                            inputProps={{ maxLength: 6, id: 'qtr_from' }}
                            data-testid='fromQuarter'
                            label='qtr_from'
                            onChange={(e) =>
                              dispatch(selectedFromQtr(e.target.value))
                            }
                            onBlur={(e) => {
                              blurHandler(
                                autoFormateDate(e.target.value?.toUpperCase()),
                                'fromQtr'
                              );
                            }}
                            disabled={qtr_opt !== 'Quarter'}
                            error={
                              flderror?.qtrFromReqErr ||
                              flderror?.qtrFromValidErr
                            }
                          />
                        </div>
                        <span>to</span>
                        <div className='mui-custom-form no-margin col-3  pl-2 pr-0 no-lbl mandate-fields'>
                          <TextField
                            value={acc_qtr_to}
                            id='qtr_to'
                            data-testid='toQuarter'
                            className='frr-display-hidden-label'
                            inputProps={{
                              id: 'qtr_to',
                              maxLength: 6,
                            }}
                            label='qtr_to'
                            onChange={(e) =>
                              dispatch(selectedToQtr(e.target.value))
                            }
                            onBlur={(e) => {
                              blurHandler(
                                autoFormateDate(e.target.value?.toUpperCase()),
                                'toQtr'
                              );
                            }}
                            disabled={qtr_opt !== 'Quarter'}
                            error={flderror?.qtrToValidErr}
                          />
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </fieldset>
          </div>
          <div className='col-12 mt-2 '>
            <FormControlLabel
              control={<Checkbox color='primary' />}
              label='All Manufacturers'
              value={all_manu}
              disabled={display_by !== 'Manufacturer'}
              onChange={(e, val) => {
                dispatch(allManufacturer(val));
                setSingleManu(null);
                if (!val) {
                  setLoad(true);
                  dispatch(
                    storeManufacturesList({
                      planType: plan_type,
                      isAllRpc: all_rebate,
                    })
                  );
                } else {
                  const err = removeErr(err_list, [MFG_REQ_ERR]);
                  dispatch(errorMsg(err));
                }
              }}
              checked={all_manu}
              data-testid='check-box-manu'
            />
          </div>
        </>
      )}
      {!all_manu && display_by === 'Manufacturer' && (
        <div className=''>
          <TableGrid
            data-testid='manufacture-grid'
            gridHeight={fullScreen ? '70vh' : 400}
            rowData={manu_list || []}
            gridCall={onGridReady}
            columnDefs={columnDefs}
            fileName='Manufacturers'
            onSelectionChanged={onSelectionChanged}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            fullScreenView={fullScreen}
            handleFullScreenViewClick={() => setFullScreen(!fullScreen)}
            exportFile
            suppressCellFocus
            onCellFocused={onCellFocused}
            helpMessage={Constants.DOUBLE_CLICK_INFO}
            cellClickedListener={cellClickedListener}
          />
        </div>
      )}
    </div>
  );
};

export default ReqAccReceivable;
